<template>
  <div class="problem">
    <div class="box" v-show="problemObj.UActivityFlag === 1">
      <h3>购买课程<span class="red">有什么优惠？</span></h3>
      <p>新用户：注册成功后48小时内，购课满200减10，满400减30，满600减60，满1200减150，满2400减350，满4800减580。</p>
      <p class="mgt18">老用户：累计购课满300，再次购课8.5折优惠。</p>
    </div>
    <div class="box" v-show="problemObj.TeachingMaterialFlag === 1 || problemObj.TeachingAssistFlag === 1">
      <h3>何时<span class="red">寄送书籍资料（教材/教辅）？</span></h3>
      <p>若您报名的班级包含赠送教材/教辅配套服务，有两种情况：</p>
      <h4>情况1：教材和教辅资料已出版</h4>
      <p>默认购课7天后安排邮寄，若急需教材，请联系客服加急处理。</p>
      <h4>情况2：教材和教辅资料未出版</h4>
      <p>教材上市后，根据购买课程的先后顺序安排邮寄；教辅《通关宝典》一般在考前1-2个月邮寄，具体请查看课程介绍。</p>
    </div>
    <div class="box">
      <h3>是否为新课程？</h3>
      <p>您购买所有课程均为新版本，每年新教材上市或大纲修订，课程将及时更新。大纲/教材未出版前，赠送旧版课程方便用户提前复习，课程更新后可学习新版课程。</p>
    </div>
    <div :class="que1 ? 'box' : 'box mgr0'">
      <h3>课程<span class="red">有效期是多久？</span></h3>
      <p>网校所有课程都设置了有效期，考试项目不同有效期也不同，可查看课程旁有效期提醒。课程有效期是根据考试周期进行合理设定，部分班级含不过免费重学服务，具体请看课程介绍。</p>
    </div>
    <div class="box" v-show="que1">
      <h3>报名支付后，如何开始听课学习？</h3>
      <p>电脑端听课流程：登录网校 -- 进入我的课程即可开始学习</p>
      <p class="mgt18">APP端听课流程：下载APP--我的课程--开始学习，支持离线下载学习。</p>
    </div>
    <div class="box mgr0" v-show="que1">
      <h3>双师资是什么？</h3>
      <p>包含双师资的课程在报名后两位老师的课程都可以听，都是完整版本，用户可以任意选择一位喜欢的老师听课，听课过程中可以随时切换到另外一位老师。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Problem",
  props: {
    problemObj: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    que1() {
      return this.problemObj.UActivityFlag !== 1 || !(this.problemObj.TeachingMaterialFlag === 1 || this.problemObj.TeachingAssistFlag === 1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/index.scss";
.problem{
  width: 1200px;
  margin: 0 auto 57px;
  display: flex;
  .box{
    background: #FFFFFF;
    box-shadow: 1px 15px 18px 1px rgba(0, 0, 0, 0.02);
    margin-right: 16px;
    padding: 0 18px 18px;
    position: relative;
    &::before{
      content: "";
      width: 60px;
      height: 2px;
      @include problem_background();
      position: absolute;
      top: 0;
      left: 20px;
    }
    h3{
      color: #565656;
      font-size: 16px;
      font-weight: bold;
      margin: 32px 0 18px;
    }
    .red{
      @include problem_color();
    }
    p{
      color: #888;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
    }
    h4{
      color: #565656;
      font-size: 14px;
      font-weight: bold;
    }
    .mgt18{
      margin-top: 18px;
    }
    &:nth-child(1){
      width: 260px;
    }
    &:nth-child(2){
      width: 260px;
    }
    &:nth-child(5){
      width: 260px;
    }
    &:nth-child(4){
      min-width: 144px;
    }
    &:nth-child(3), &:nth-child(4), &:nth-child(6){
      flex: 1;
    }
  }
  .mgr0{
    margin-right: 0;
  }
}
</style>